import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const IDLE_MS = 2 * 60 * 1000; // 2 minutos
const EVENTS = ['touchstart', 'touchmove', 'click', 'keydown', 'scroll'];

export default function useIdleLogout() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const timer = useRef(null);

  useEffect(() => {
    // Ativa somente em dispositivos mobile (mesma breakpoint do CSS)
    if (window.innerWidth > 768 && navigator.maxTouchPoints === 0) return;

    const doLogout = () => {
      logout();
      navigate('/login', { replace: true });
    };

    const reset = () => {
      clearTimeout(timer.current);
      timer.current = setTimeout(doLogout, IDLE_MS);
    };

    reset();
    EVENTS.forEach(ev => window.addEventListener(ev, reset, { passive: true }));

    return () => {
      clearTimeout(timer.current);
      EVENTS.forEach(ev => window.removeEventListener(ev, reset));
    };
  }, [logout, navigate]);
}
